import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';

const OldPosts = () => {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const listRes = await fetch(`${process.env.PUBLIC_URL}/postList.json`);
        const data = await listRes.json();
        const slugs = (data.oldPosts || []).map(file => file.replace('.md', ''));
        setPosts(slugs);
      } catch (e) {}
    };
    fetchPosts();
  }, []);
  return (
    <ul>
      {posts.map(slug => (
        <li key={slug}><Link to={`/reading/${slug}`}>{slug}</Link></li>
      ))}
    </ul>
  );
};

const OldBackrooms = () => {
  const [dyads, setDyads] = useState({});
  useEffect(() => {
    const fetchBackrooms = async () => {
      try {
        const listRes = await fetch(`${process.env.PUBLIC_URL}/backroomsList.json`);
        const data = await listRes.json();
        setDyads(data.dyads || {});
      } catch (e) {}
    };
    fetchBackrooms();
  }, []);
  return (
    <div>
      {Object.entries(dyads).map(([dyad, conversations]) => (
        <div key={dyad}>
          <h3 style={{ fontSize: '1rem', marginTop: '1.5em', marginBottom: '0.5em', color: '#7aaab0' }}>{dyad}</h3>
          <ul>
            {conversations.map(conv => {
              const slug = conv.replace('.md', '');
              return (
                <li key={slug}>
                  <Link to={`/lurkingIn/${dyad}/${slug}`}>{slug}</Link>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </div>
  );
};

const Archive = () => {
  const { tab } = useParams();
  const navigate = useNavigate();
  const activeTab = tab || 'oldposts';

  return (
    <div className="archive">
      <nav style={{ marginBottom: '1.5em' }}>
        <span
          onClick={() => navigate('/archive/oldposts')}
          style={{
            cursor: 'pointer',
            marginRight: '1.5em',
            borderBottom: activeTab === 'oldposts' ? '1px solid #b0e0e6' : 'none',
            paddingBottom: '2px'
          }}
        >
          old posts
        </span>
        <span
          onClick={() => navigate('/archive/oldbackrooms')}
          style={{
            cursor: 'pointer',
            borderBottom: activeTab === 'oldbackrooms' ? '1px solid #b0e0e6' : 'none',
            paddingBottom: '2px'
          }}
        >
          old backrooms
        </span>
      </nav>
      {activeTab === 'oldposts' && <OldPosts />}
      {activeTab === 'oldbackrooms' && <OldBackrooms />}
    </div>
  );
};

export default Archive;
